var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhiteContent = function SvgGradientWhiteContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.05 15.175H1.007c-.43 0-.717-.287-.717-.717V1.548c0-.43.287-.717.717-.717h6.455l4.303 4.303v9.324c0 .43-.287.717-.717.717Zm-2.87-3.586c0-.43-.287-.717-.717-.717H3.16c-.43 0-.717.287-.717.717s.287.717.717.717h4.303c.43 0 .717-.287.717-.717Zm1.435-3.586c0-.43-.287-.717-.718-.717H3.16c-.43 0-.717.287-.717.717s.287.717.717.717h5.737c.43 0 .718-.287.718-.717Zm0-3.586c0-.43-.287-.717-.718-.717H3.16c-.43 0-.717.286-.717.717 0 .43.287.717.717.717h5.737c.43 0 .718-.287.718-.717Z",
    fill: "url(#gradient-white-content_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18 5.134h3.586L7.463.831v3.586c0 .43.287.717.717.717Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-content_svg__a",
    x1: 6.029,
    y1: 0.831,
    x2: 6.029,
    y2: 15.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0.3
  })))));
};

export default SvgGradientWhiteContent;